module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/budget_en-82853eb52404a4994391218b46b11181.webp";